module.exports = __webpack_public_path__ + "static/media/left.78bf29d5.svg";